// source: pbtypes/gen/flight_connect/device_node_link_health.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_transport_state_pb = require('../../../pbtypes/gen/flight_connect/transport_state_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_state_pb);
var pbtypes_gen_flight_connect_transport_type_pb = require('../../../pbtypes/gen/flight_connect/transport_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_type_pb);
goog.exportSymbol('proto.flight_connect.DeviceNodeLinkHealth', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceNodeLinkHealth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.DeviceNodeLinkHealth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceNodeLinkHealth.displayName = 'proto.flight_connect.DeviceNodeLinkHealth';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceNodeLinkHealth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceNodeLinkHealth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodeLinkHealth.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
state: jspb.Message.getFieldWithDefault(msg, 2, 0),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
rxEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
txEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
rttMs: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceNodeLinkHealth}
 */
proto.flight_connect.DeviceNodeLinkHealth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceNodeLinkHealth;
  return proto.flight_connect.DeviceNodeLinkHealth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceNodeLinkHealth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceNodeLinkHealth}
 */
proto.flight_connect.DeviceNodeLinkHealth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_connect.TransportState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRxEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTxEnabled(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRttMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceNodeLinkHealth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceNodeLinkHealth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodeLinkHealth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRxEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTxEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRttMs();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional TransportType.Enum type = 1;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getType = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TransportState.Enum state = 2;
 * @return {!proto.flight_connect.TransportState.Enum}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getState = function() {
  return /** @type {!proto.flight_connect.TransportState.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_connect.TransportState.Enum} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool enabled = 3;
 * @return {boolean}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool rx_enabled = 4;
 * @return {boolean}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getRxEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setRxEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool tx_enabled = 5;
 * @return {boolean}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getTxEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setTxEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional uint32 rtt_ms = 6;
 * @return {number}
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.getRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodeLinkHealth} returns this
 */
proto.flight_connect.DeviceNodeLinkHealth.prototype.setRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


goog.object.extend(exports, proto.flight_connect);
